<script setup lang="ts">
import type { NavigationTreeFragment } from '#graphql-operations'

const { locale } = useI18n()
const variables = computed(() => ({ site: [locale.value] }))

const siteConfig = useSiteConfig()
const { data: searchData } = await useSearchQuery()
const { data } = useAsyncGraphqlQuery('HeaderNavigation', variables, { transform: response => response.data })

const headerLeftNav = computed(() => data?.value?.headerLeft as NavigationTreeFragment[])
const headerRightNav = computed(() => data?.value?.headerRight as NavigationTreeFragment[])
const headerNav = computed(() => [...headerLeftNav.value, ...headerRightNav.value])

const headerRef = useCurrentElement<HTMLElement>()
const { height } = useElementSize(headerRef)

const headerHeight = useCssVar('--header-height')

watch(height, () => {
  headerHeight.value = `${Math.round(height.value)}px`
})

const searchDrawerApi = useMagicDrawer('search-drawer')
</script>

<template>
  <header id="site-header" class="theHeader left-0 right-0 top-0 sticky z-4">
    <div class="container py-3 bg-white flex h-13.5 items-center justify-between lg:py-5 lg:h-17">
      <div class="flex flex-1 items-center">
        <HeaderNav :nav="headerLeftNav" />
      </div>
      <Anchor to="/" class="logo flex-none block relative z-2">
        <SiteSwitchComponent name="logo" />
        <span class="sr-only">{{ siteConfig.name }}</span>
      </Anchor>
      <div class="flex flex-1 items-center justify-end">
        <HeaderNav :nav="headerRightNav">
          <li v-if="!searchData?.disabled" class="headerNavLink inline-flex relative z-2">
            <MagicDrawerProvider id="navigation-drawer">
              <MagicDrawerTrigger as-child>
                <ButtonNav :title="$t('search')" @click="searchDrawerApi.open" />
              </MagicDrawerTrigger>
            </MagicDrawerProvider>
          </li>
        </HeaderNav>
        <TheNavigationMobile :nav="headerNav" />
      </div>
    </div>
  </header>
</template>

<style scoped>
.theHeader {
  color: var(--colors-primary);
  transition: color 350ms var(--ease-custom-circ);
}

.theHeader:has(.submenu.open) {
  color: var(--colors-linen);
}

.theHeader:has(.submenu.open) .logo {
  color: var(--accent-color);
}
</style>
